(function () {
  "use strict";

  class ConvxSlider extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null; // Store Flickity instance
    }

    connectedCallback() {
      this.initFlickity();
      window.addEventListener("resize", this.updateFlickity.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.updateFlickity.bind(this));
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }

    getFlickityOptions() {
      const defaultOptions = window.innerWidth < 768
        ? { cellAlign: "center", contain: true, groupCells: true, imagesLoaded: true }
        : { cellAlign: "left", contain: true, groupCells: false, imagesLoaded: true };

      // Get custom options from data attribute
      let customOptions = {};
      try {
        const optionsString = this.getAttribute('data-options');
        if (optionsString) {
          customOptions = JSON.parse(optionsString);
        }
      } catch (error) {
        console.warn('Invalid data-options format:', error);
      }

      // Merge default options with custom options
      return { ...defaultOptions, ...customOptions };
    }

    initFlickity() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
      this.flickityInstance = new Flickity(this, this.getFlickityOptions());
    }

    updateFlickity() {
      this.initFlickity();
    }
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    customElements.define("convx-slider", ConvxSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
